import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["sprite"]

  mousemove(e) {
    this._scrub({ x: e.clientX })
  }

  touchmove(e) {
    const touch = e.changedTouches[0]

    if (this.element.dataset.scrubTouch == "vertical") {
      this._scrub({ y: touch.clientY })
    } else {
      this._scrub({ x: touch.clientX })
    }
  }

  touchstart() {
    document.documentElement.classList.add("is-horizontally-scrolling")
  }

  touchend() {
    document.documentElement.classList.remove("is-horizontally-scrolling")
  }

  restart() {
    this._imageMove(0)
  }

  _scrub({ x, y }) {
    const imageCount = 20
    const bounds = this.element.getBoundingClientRect()
    const sliceCount = (bounds.width / imageCount) - 1

    const position = x ? x - bounds.left : y - bounds.top
    let index = Math.floor(position / sliceCount)
    if (index < 0 || imageCount <= index) index = 0

    this._imageMove(index * bounds.height)
  }

  _imageMove(top) {
    requestAnimationFrame(() => {
      // translateZ for a faster animation
      this.spriteTarget.style.transform = `translateY(${-top}px) translateZ(0)`
    })
  }
}
